import React, { FC, memo } from "react";
import { createUseStyles } from "react-jss";

import Trails from "Assets/images/trails.svg";
import { areEqualShallow } from "Utils/areEqual";
import styles from "./styles";

interface Props {
  onClick: (e: any) => void;
  className?: string;
}
const TrailsIcon: FC<Props> = memo(({ onClick, className = "" }: Props) => {
  const classes = createUseStyles(styles)();
  const click = (e: any) => {
    // e.preventDefault();
    if (onClick) onClick(e);
  };
  return (
    <Trails
      id="trailsIcon"
      data-testid="trailsIcon"
      className={`${classes.pointer} ${className}`}
      onClick={click}
    />
  );
}, areEqualShallow);
TrailsIcon.defaultProps = {
  className: undefined,
};
export default TrailsIcon;
